import { render, staticRenderFns } from "./PricingHeader.vue?vue&type=template&id=0134fe6c&scoped=true&"
import script from "./PricingHeader.vue?vue&type=script&lang=js&"
export * from "./PricingHeader.vue?vue&type=script&lang=js&"
import style0 from "./PricingHeader.vue?vue&type=style&index=0&id=0134fe6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0134fe6c",
  null
  
)

export default component.exports